module.exports = __webpack_public_path__ + "static/media/slack.ca363e00.svg";